export const NAVIGATION_LIST = [
  { name: "home", to: "home" },
  { name: "brands", to: "brands" },
  { name: "products", to: "products" },
  { name: "careers", to: "careers" },
];
